(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9344],{

/***/ 62505:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login",
      function () {
        return __webpack_require__(49082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 7499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "login-form": __webpack_require__(26030)
};


/***/ }),

/***/ 50216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "login-form": __webpack_require__(57753),
    "login-page": __webpack_require__(49705),
    "registration-form": __webpack_require__(18868)
};


/***/ }),

/***/ 11266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(50216),
    de: __webpack_require__(7499)
};


/***/ }),

/***/ 49082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ auth_login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/AuthContainer/index.js









const signInUtilityProps = {
    bgColor: "black--02",
    sm: {
        border: {
            top: {
                width: 1,
                color: "black--10"
            }
        }
    },
    md: {
        border: {
            top: {
                width: 0
            },
            left: {
                width: 1,
                color: "black--10"
            }
        }
    }
};
const AuthContainerSignIn = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        md: 5,
        id: "signInSection",
        spacing: {
            py: 16
        },
        utility: signInUtilityProps,
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                justify: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                md: 9,
                children: children
            })
        })
    });
};
AuthContainerSignIn.propTypes = {
    children: prop_types.node.isRequired
};
const AuthContainerSignUp = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        id: "signUpSection",
        md: 7,
        spacing: {
            py: 16
        },
        utility: {
            bgColor: "white"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            utility: {
                justify: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                md: 10,
                children: children
            })
        })
    });
};
AuthContainerSignUp.propTypes = {
    children: prop_types.node.isRequired
};
const AuthContainerTitle = (param)=>{
    let { weight , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        Tag: "h2",
        sx: {
            fontSize: "xl",
            fontWeight: weight,
            textAlign: "center",
            ...(0,pureProps/* default */.Z)(sx)
        },
        spacing: {
            mb: 10,
            ...(0,pureProps/* default */.Z)(spacing)
        },
        className: className,
        ...props,
        children: children
    });
};
AuthContainerTitle.propTypes = {
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    ...Heading/* default.propTypes */.Z.propTypes
};
const AuthContainer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: children
            })
        })
    });
};
AuthContainer.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var molecules_AuthContainer = (AuthContainer);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(39116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js + 8 modules
var SmartForm = __webpack_require__(3816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./src/utils/useResultStatus/index.js
var useResultStatus = __webpack_require__(4116);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./src/services/auth.js + 4 modules
var auth = __webpack_require__(5803);
// EXTERNAL MODULE: ./src/apollo/operation-errors.js
var operation_errors = __webpack_require__(99092);
// EXTERNAL MODULE: ./src/nprogress.js
var nprogress = __webpack_require__(24753);
// EXTERNAL MODULE: ./src/services/unexpectedError.js
var unexpectedError = __webpack_require__(12162);
;// CONCATENATED MODULE: ./src/LoginForm/action.js







const login = (form)=>auth/* login */.x4(form).then((0,routes/* followToReturlUrl */._d)({
        fallback: routes/* default.myAccount */.ZP.myAccount
    })).catch((0,fn/* mapErrors */.wc)(operation_errors/* default */.ZP)).catch((0,unexpectedError/* detectUnexpectedError */.O)({
        expected: [
            404
        ]
    }));
/* harmony default export */ var LoginForm_action = ((0,pipe/* default */.Z)(login, (0,nprogress/* withLoading */.VT)("login")));

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 6 modules
var validation = __webpack_require__(89965);
;// CONCATENATED MODULE: ./src/LoginForm/form.js

const initialState = {
    email: "",
    password: ""
};
const schema = {
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isSimpleEmail */.QZ,
            "errors.WRONG_EMAIL"
        ]
    ],
    password: [
        [
            validation/* required */.C1,
            "errors.PSWD_REQUIRED"
        ],
        [
            (0,validation/* maxLen */.g3)(64),
            "errors.PSWD_TOO_LONG"
        ]
    ]
};
const validateForm = (0,validation/* default */.ZP)(schema);

;// CONCATENATED MODULE: ./src/LoginForm/index.js















function LoginForm() {
    const [t] = (0,i18/* useLocale */.bU)("login-form");
    const [loginAction, isSigningIn] = (0,useTracking/* default */.ZP)(LoginForm_action, useTracking/* CATCH */.av);
    const [action, { errors  }, resetResult] = (0,useResultStatus/* default */.Z)(loginAction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSigningIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContainerTitle, {
                id: "equalHeightSource",
                "data-qa-selector": "signIn-form-title",
                children: t("FORM_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                textRender: t,
                initialState: initialState,
                validateForm: validateForm,
                action,
                onTouched: resetResult,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "EMAIL",
                        name: "email",
                        type: "email",
                        disabled: isSigningIn,
                        error: errors.localeMessage,
                        fieldClassName: "mb-8",
                        maxLength: 100,
                        required: true,
                        "data-qa-selector": "signIn-email-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "PASSWORD",
                        name: "password",
                        type: "password",
                        disabled: isSigningIn,
                        error: errors.localeMessage,
                        fieldClassName: "mb-8",
                        maxLength: 65,
                        required: true,
                        "data-qa-selector": "signIn-password-input",
                        link: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            size: "s",
                            href: routes/* default.forgotPassword */.ZP.forgotPassword,
                            "data-qa-selector": "signIn-forgot-link",
                            children: t("FORGOT_PASSWORD")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            spacing: {
                                mt: 4,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disabled: isSigningIn,
                                    "data-qa-selector": "signIn-submit-button",
                                    children: t("SIGN_IN")
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var src_LoginForm = (LoginForm);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
;// CONCATENATED MODULE: ./src/RegistrationForm/form.js

const form_initialState = {
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    password: "",
    pswdConfirm: ""
};
const form_schema = {
    firstName: [
        validation/* required */.C1,
        "errors.FIRST_NAME_REQUIRED"
    ],
    lastName: [
        validation/* required */.C1,
        "errors.LAST_NAME_REQUIRED"
    ],
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isEmail */.Jh,
            "errors.WRONG_EMAIL"
        ]
    ],
    password: [
        [
            validation/* required */.C1,
            "errors.PSWD_REQUIRED"
        ],
        (0,validation/* join */.v_)((0,validation/* rule */.jR)((0,validation/* minLen */.bV)(6), "$t(errors.PSWD_TOO_SHORT)"), (0,validation/* rule */.jR)((0,validation/* maxLen */.g3)(64), "$t(errors.PSWD_TOO_LONG)"), (0,validation/* rule */.jR)((0,validation/* match */.EQ)(/\d/), "$t(errors.PSWD_AT_LEAST_1_DIGIT)"))
    ],
    pswdConfirm: [
        [
            validation/* required */.C1,
            "errors.CFRM_PSWD_REQUIRED"
        ],
        [
            (0,validation/* isTheSame */.Y1)("password"),
            "errors.CFRM_SHOULD_MATCH_PSWD"
        ]
    ]
};
const form_validateForm = (0,validation/* default */.ZP)(form_schema);

;// CONCATENATED MODULE: ./src/RegistrationForm/action.js






const register = (form)=>auth/* register */.z2(form).then((0,routes/* followToReturlUrl */._d)({
        fallback: routes/* default.myAccount */.ZP.myAccount
    })).catch((0,fn/* mapErrors */.wc)(operation_errors/* default */.ZP));
/* harmony default export */ var RegistrationForm_action = ((0,pipe/* default */.Z)(register, (0,nprogress/* withLoading */.VT)("sign-up")));

;// CONCATENATED MODULE: ./src/RegistrationForm/index.js















function RegistrationForm() {
    const [t] = (0,i18/* useLocale */.bU)("registration-form");
    const [regAction, isSigningUp] = (0,useTracking/* default */.ZP)(RegistrationForm_action, useTracking/* CATCH */.av);
    const [action, { errors  }, resetResult] = (0,useResultStatus/* default */.Z)(regAction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSigningUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContainerTitle, {
                id: "equalHeightSource",
                "data-qa-selector": "signUp-form-title",
                children: t("FORM_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                textRender: t,
                initialState: form_initialState,
                validateForm: form_validateForm,
                action,
                onTouched: resetResult,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "FIRST_NAME",
                        name: "firstName",
                        disabled: isSigningUp,
                        fieldClassName: "mb-8",
                        maxLength: 50,
                        required: true,
                        "data-qa-selector": "signUp-first-name-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "LAST_NAME",
                        name: "lastName",
                        disabled: isSigningUp,
                        fieldClassName: "mb-8",
                        maxLength: 50,
                        required: true,
                        "data-qa-selector": "signUp-last-name-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "COMPANY_NAME",
                        name: "company",
                        disabled: isSigningUp,
                        fieldClassName: "mb-8",
                        maxLength: 50,
                        "data-qa-selector": "signUp-company-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "EMAIL",
                        name: "email",
                        type: "email",
                        disabled: isSigningUp,
                        error: errors.message,
                        fieldClassName: "mb-8",
                        maxLength: 100,
                        required: true,
                        "data-qa-selector": "signUp-email-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "PASSWORD",
                        name: "password",
                        type: "password",
                        disabled: isSigningUp,
                        fieldClassName: "mb-8",
                        maxLength: 65,
                        required: true,
                        "data-qa-selector": "signUp-password-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "CONFIRM_PASSWORD",
                        name: "pswdConfirm",
                        type: "password",
                        disabled: isSigningUp,
                        fieldClassName: "mb-8",
                        maxLength: 65,
                        required: true,
                        "data-qa-selector": "signUp-password-confirm-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            spacing: {
                                mt: 4,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disabled: isSigningUp,
                                    "data-qa-selector": "signUp-submit-button",
                                    children: t("GET_STARTED")
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                        Tag: "p",
                        className: "text-s text-center",
                        children: t("USER_LEGAL_CONCENT", {
                            tosLink: routes/* default.external.termsOfService */.ZP.external.termsOfService,
                            ppLink: routes/* default.external.privacyPolicy */.ZP.external.privacyPolicy
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var src_RegistrationForm = (RegistrationForm);

// EXTERNAL MODULE: ./src/utils/redirectIf/index.js
var redirectIf = __webpack_require__(12675);
// EXTERNAL MODULE: ./locales/login-page/index.js
var login_page = __webpack_require__(11266);
var login_page_default = /*#__PURE__*/__webpack_require__.n(login_page);
;// CONCATENATED MODULE: ./pages/auth/login.js














const RegisterLoginPage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("login-page");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("PAGE_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(molecules_AuthContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContainerSignUp, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_RegistrationForm, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContainerSignIn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_LoginForm, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var auth_login = ((0,pipe/* default */.Z)(RegisterLoginPage, (0,i18/* WithLocale */._t)({
    resources: (login_page_default())
}), (0,redirectIf/* default */.ZP)(auth/* isAuthorized */.QO, (0,routes/* toReturnUrl */.YT)(routes/* default.myAccount */.ZP.myAccount)), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 99092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ getExceptionFields; },
/* harmony export */   "ZU": function() { return /* binding */ GraphQLNetworkException; }
/* harmony export */ });
/* unused harmony exports netError, gqlError */
/* harmony import */ var _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28813);

const getMessage = (param)=>{
    let { extensions: { errors  } , message  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors[0].message || message : message;
};
const getExtensionsErrors = (param)=>{
    let { path , code , extensions: { errors  }  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors.map((error)=>"graphql:".concat(path, ".").concat(error.type ? error.message : code)) : [
        "graphql:".concat(path, ".").concat(code)
    ];
};
const getExceptionFields = (originalError)=>[
        getMessage(originalError),
        originalError.code,
        getExtensionsErrors(originalError),
        originalError
    ];
/** @TODO: Extract class to ActionFailException */ class GraphQLNetworkException extends _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
}
const netError = (param)=>{
    let { networkError  } = param;
    return networkError ? new GraphQLNetworkException(networkError.message, networkError.code) : null;
};
const gqlError = (param)=>{
    let { graphQLErrors  } = param;
    return (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.length) > 0 ? new _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(...getExceptionFields(graphQLErrors[0])) : null;
};
const getOperationError = (err)=>err instanceof _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z ? err : gqlError(err) || netError(err);
/* harmony default export */ __webpack_exports__["ZP"] = (getOperationError);


/***/ }),

/***/ 12162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ detectUnexpectedError; }
/* harmony export */ });
/* harmony import */ var _apollo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75469);
/* harmony import */ var _graphql_local_unexpectedError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51041);


const detectUnexpectedError = function() {
    let { expected  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        expected: []
    };
    return (error)=>{
        if (!expected.includes(error.code)) {
            (0,_apollo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().writeData({
                data: {
                    unexpectedError: (0,_graphql_local_unexpectedError__WEBPACK_IMPORTED_MODULE_1__/* .createError */ .Tr)(error)
                }
            });
        }
        return Promise.reject(error);
    };
};


/***/ }),

/***/ 28813:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
class ActionFailException extends Error {
    /** @constructor
	 * @type {(message: string, code: null | string | number, stack: string[], originalError: Error)}
	 */ constructor(message, code = null, stack = [], originalError = {}){
        super("ActionFailException");
        this.name = this.constructor.name;
        this.code = code;
        this.message = message;
        /** @TODO: rename `stack` field to `details` */ this.stack = stack;
        this.originalError = originalError;
        this.localeMessage = this.stack[0] || this.message;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (ActionFailException);


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ }),

/***/ 4116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37894);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28813);





const actionFallback = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((err)=>{
        if (!(err instanceof _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) {
            // rethrowing err if it's not an ActionFailException
            throw err;
        }
        // suppressing ActionFailException
        setResultStatus({
            errors: err,
            hasErrors: true
        });
    });
const actionSuccess = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((result)=>{
        setResultStatus({
            result,
            errors: {},
            hasErrors: false
        });
        return result;
    });
const actionEnhancer = (setResultStatus)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(actionFallback(setResultStatus), actionSuccess(setResultStatus));
const getInitialState = ()=>({
        errors: {},
        hasErrors: false,
        result: undefined
    });
const useUniEffect = react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useResultStatus(action) {
    const unmounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const [resultStatus, setResultStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState);
    const statusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    statusRef.current = resultStatus;
    useUniEffect(()=>()=>{
            unmounted.current = true;
        }, []);
    const updateResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((result)=>{
        if (unmounted.current) return;
        setResultStatus(result);
    }, []);
    const withResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>actionEnhancer(updateResultStatus)(// fallback decorator
        function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            setResultStatus(getInitialState);
            return action(...args);
        }), [
        action
    ]);
    const resetResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (statusRef.current.hasErrors) {
            // if there is no error, so there is no need to reset status
            setResultStatus(getInitialState);
        }
    }, []);
    return [
        withResultStatus,
        resultStatus,
        resetResult
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useResultStatus);


/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 37894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const fallback = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const theHandler = (err)=>handler(err, ...args);
            try {
                const result = fn(...args);
                return (0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.catch(theHandler) : result;
            } catch (err) {
                return theHandler(err);
            }
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (fallback);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 4354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ withForceError; }
/* harmony export */ });
/* unused harmony export throwError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _displayName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75511);
/* harmony import */ var _ApplicationError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66651);







const getCurrentPath = (param)=>{
    let { asPath  } = param;
    return asPath;
};
const getQueryParam = function() {
    let paramName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "throw";
    return (pathname)=>(0,_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(pathname)[paramName];
};
const parseErrorParams = (wsParamValue)=>/(-?\d+)-([^-].*)/.exec(wsParamValue) || [];
const normalizeParams = (param)=>{
    let [, code, message] = param;
    return [
        code && parseInt(code, 10),
        message
    ];
};
const getErrorParamsFromPath = (paramName)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(normalizeParams, parseErrorParams, getQueryParam(paramName), getCurrentPath);
const throwError = (getInitialProps, paramName)=>(context)=>{
        const [code, message] = getErrorParamsFromPath(paramName)(context);
        if (code == null) {
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .isFunc */ .Wl)(getInitialProps) ? getInitialProps(context) : {
                __throwError: true
            };
        }
        if (code < 0) throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Server Side: ".concat(message)), -code, "Server Side: ".concat(message));
        return {
            errorToThrow: {
                code,
                message
            }
        };
    };
/** @type {(paramName: string) => <P extends {}>(Component: React.Component<P>) => React.FC<P>} */ const withForceErrorHOC = (paramName)=>(Component)=>{
        const ComponentWithThrowError = (param)=>{
            let { errorToThrow , ...props } = param;
            if (errorToThrow && "object" !== "undefined") throw new _ApplicationError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(new Error("Client Side: ".concat(errorToThrow.message)), errorToThrow.code, "Client Side: ".concat(errorToThrow.message));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        };
        ComponentWithThrowError.propTypes = {
            ...Component.propTypes,
            errorToThrow: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.shape)({
                code: prop_types__WEBPACK_IMPORTED_MODULE_5__.number,
                message: prop_types__WEBPACK_IMPORTED_MODULE_5__.string
            })
        };
        ComponentWithThrowError.displayName = (0,_displayName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("withForceError", Component);
        ComponentWithThrowError.getInitialProps = throwError(Component.getInitialProps, paramName);
        return ComponentWithThrowError;
    };
const withForceError = withForceErrorHOC;


/***/ }),

/***/ 73446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const PageTitle = (param)=>{
    let { title  } = param;
    return title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "title")
        ]
    }) : null;
};
PageTitle.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 89333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11987);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97334);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_1__);


const query = (path)=>querystring__WEBPACK_IMPORTED_MODULE_1___default().parse((0,url__WEBPACK_IMPORTED_MODULE_0__.parse)(path).query);
/* harmony default export */ __webpack_exports__["Z"] = (query);


/***/ }),

/***/ 26030:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"FORM_TITLE":"de:Sign In","EMAIL":"de:Email","PASSWORD":"de:Password","FORGOT_PASSWORD":"de:Forgot your password?","STAY_SIGNED_IN":"de:Stay signed in for 30 days","SIGN_IN":"de:Sign In"}');

/***/ }),

/***/ 57753:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"FORM_TITLE":"Sign In","EMAIL":"Email","PASSWORD":"Password","FORGOT_PASSWORD":"Forgot your password?","SIGN_IN":"Sign In","errors":{"EMAIL_REQUIRED":"Please enter your email.","WRONG_EMAIL":"Please enter valid email.","EMAIL_INVALID_LENGTH":"Please enter valid email(up to 64 characters).","PSWD_REQUIRED":"Please enter your password.","PSWD_TOO_LONG":"Password can’t be longer than 64 characters."}}');

/***/ }),

/***/ 49705:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"PAGE_TITLE":"Sign In - SnapGene","ACADEMY_TITLE":"Sign in to SnapGene Academy","ACADEMY_SUB_TITLE":"Master SnapGene and key concepts in molecular biology and cloning with our free online learning center. Sign in to SnapGene Academy with your SnapGene account or create a new account.","LEARN_MORE":"Have questions? Learn more about SnapGene Academy."}');

/***/ }),

/***/ 18868:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"FORM_TITLE":"Create a New Account","FIRST_NAME":"First Name","LAST_NAME":"Last Name","COMPANY_NAME":"Company / Organization (optional)","EMAIL":"Email","PASSWORD":"Password","CONFIRM_PASSWORD":"Confirm Password","GET_STARTED":"Get Started","USER_LEGAL_CONCENT":"By clicking \\"Get Started\\" you agree to SnapGene\'s $t(links:TERMS) and $t(links:POLICY).","errors":{"FIRST_NAME_REQUIRED":"Please enter your first name.","LAST_NAME_REQUIRED":"Please enter your last name.","EMAIL_REQUIRED":"Please enter your email.","WRONG_EMAIL":"Please enter valid email.","EMAIL_INVALID_LENGTH":"Please enter valid email(up to 64 characters).","PSWD_REQUIRED":"Please enter your password.","PSWD_TOO_SHORT":"Your password must be at least 6 characters.","PSWD_TOO_LONG":"Password can’t be longer than 64 characters.","PSWD_AT_LEAST_1_DIGIT":"Password should contain at least one number","CFRM_PSWD_REQUIRED":"Please confirm your password.","CFRM_SHOULD_MATCH_PSWD":"The passwords do not match"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8930,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(62505); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);